"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../../../../config.json"));

var _icons = require("@ant-design/icons");

//import {useHistory} from 'react-router-dom';
var Option = _antd.Select.Option;

var AuditForm = function AuditForm(_ref) {
  var visible = _ref.visible,
      MathsRMCode = _ref.MathsRMCode,
      EnglishRMCode = _ref.EnglishRMCode,
      onCancel = _ref.onCancel,
      RMData = _ref.RMData;
  //const history = useHistory();
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _Form$useForm = _antd.Form.useForm(),
      _Form$useForm2 = (0, _slicedToArray2.default)(_Form$useForm, 1),
      form = _Form$useForm2[0]; //const [formVisible,setFormVisible] = useState(visible);
  // eslint-disable-next-line


  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1]; // eslint-disable-next-line


  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      formFail = _useState4[0],
      setFormFail = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      arr = _useState6[0],
      setArr = _useState6[1];

  var initialFormValues = {
    subject: "",
    reason: "",
    RMCode: '',
    clCode: cl,
    Count: '',
    Audit: ''
  };
  (0, _react.useEffect)(function () {
    var url = _config.default.getRMForNoAuditResponse + cl;

    _axios.default.get(url, {
      headers: {
        'Authorization': token
      }
    }).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data); // resp.data.map(obj => {
      //  obj.date = dateFormate(obj.date);
      // })

      setArr(resp.data); // setFormFail(resp.data.length);
    }, function (err) {
      setapiError(err.response);
    });

    form.setFieldsValue(initialFormValues); // eslint-disable-next-line 
  }, []); // function dateFormate(changeDate) {
  //   let date = new Date(changeDate)
  //   let year = date.getFullYear();
  //   let month = ("0" + (date.getMonth() + 1)).slice(-2);
  //   let day = ("0" + date.getDate()).slice(-2);
  //   let todayDate = `${year}-${month}-${day}`;
  //   return todayDate;
  // }

  var onFinish = function onFinish(fieldsValue) {
    var f1 = form.getFieldsValue();
    var data = {
      subject: f1.subject,
      reason: f1.reason,
      RMCodeMath: MathsRMCode,
      RMCodeEng: EnglishRMCode,
      clCode: cl,
      Count: f1.Count,
      Audit: f1.Audit,
      RMData: RMData[0]
    };
    var url = _config.default.NoAuditResponse + cl;

    _axios.default.post(url, data).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data);
      window.location = "/clPortal/app/rm/audit";
      onCancel();
    }, function (err) {
      setapiError(err.response);
    });

    var url1 = _config.default.changeRMAuditMathsData + cl;
    var url2 = _config.default.changeRMAuditEngData + cl;
    var url3 = data.subject === "Maths" ? url1 : url2;

    _axios.default.post(url3, data).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data);
      window.location = "/clPortal/app/rm/audit";
      onCancel();
    }, function (err) {
      setapiError(err.response);
    });
  };

  var changeSubject = function changeSubject(e) {
    var initialFormValues = {
      subject: e,
      reason: "",
      RMCode: e === "Maths" ? MathsRMCode : EnglishRMCode,
      clCode: cl,
      Count: e === "Maths" ? arr.find(function (i) {
        return i.RM_code === MathsRMCode;
      }).auditCountMaths : arr.find(function (i) {
        return i.RM_code === EnglishRMCode;
      }).auditCountEng,
      Audit: e === "Maths" ? arr.find(function (i) {
        return i.RM_code === MathsRMCode;
      }).auditCountMaths > 3 ? 0 : 'NoAudit' : arr.find(function (i) {
        return i.RM_code === EnglishRMCode;
      }).auditCountEng > 3 ? 0 : 'NoAudit'
    };
    form.setFieldsValue(initialFormValues);
  };

  return formFail >= 2 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement(_icons.CloseCircleOutlined, {
    style: {
      color: "red"
    }
  }), " \u0906\u092A \u092B\u0949\u0930\u094D\u092E \u0928\u0939\u0940\u0902 \u092D\u0930 \u0938\u0915\u0924\u0947 | "), /*#__PURE__*/_react.default.createElement("p", null, "\u0907\u0938 \u092E\u0939\u0940\u0928\u0947 \u0905\u092A\u0928\u0947 2 \u092C\u093E\u0930 No Audit Response Form \u092D\u0930 \u0926\u093F\u092F\u093E \u0939\u0948 \u0964"), /*#__PURE__*/_react.default.createElement(_antd.Empty, null)) : /*#__PURE__*/_react.default.createElement(_antd.Form, {
    form: form,
    name: "basic",
    initialValues: {
      remember: true
    },
    onFinish: onFinish
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: '10px',
      fontWeight: 'bold'
    }
  }, "\u0905\u0917\u0930 \u0911\u0921\u093F\u091F \u0915\u093E\u0909\u0902\u091F 2 \u0938\u0947 \u091C\u094D\u092F\u093E\u0926\u093E \u0939\u0948 \u0924\u094B \u0911\u0921\u093F\u091F \u095E\u0948\u0932 \u0915\u0930\u0947 \u0964"), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: "Subject",
    name: "subject",
    rules: [{
      required: true,
      message: 'Please Select Subject'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    placeholder: "Select Subject",
    onChange: changeSubject
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "",
    disabled: true
  }, "Select Subject"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Maths"
  }, "Maths"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "English"
  }, "English"))), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: "RM Code \u091C\u093F\u0928\u0915\u093E \u0906\u091C \u0911\u0921\u093F\u091F \u0939\u094B\u0928\u093E \u0925\u093E?",
    name: "RMCode",
    rules: [{
      required: true,
      message: 'Please Fill RM'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "RM Code",
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: "Audit Skip Count (\u0915\u093F\u0924\u0928\u0940 \u092C\u093E\u0930 \u0907\u0938 \u092E\u0939\u0940\u0928\u0947 \u0911\u0921\u093F\u091F Skip \u0939\u094B \u091A\u0942\u0915\u093E \u0939\u0948 ?)",
    name: "Count",
    rules: [{
      required: true,
      message: 'Please Fill Audit Skip Count'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Count",
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: "Audit %",
    name: "Audit",
    rules: [{
      required: true,
      message: 'Please Fill Audit %'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Audit Percentage",
    disabled: true
  })), initialFormValues.Count < 3 ? /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    label: "\u0911\u0921\u093F\u091F \u0928\u093E \u0939\u094B\u0928\u0947 \u0915\u093E \u0915\u093E\u0930\u0923 ? (Reason) : ",
    name: "reason",
    rules: [{
      required: true,
      message: 'Please Select Reason'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Radio.Group, null, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0915\u0932 RM \u091B\u0941\u091F\u094D\u091F\u0940 \u092A\u0930 \u0925\u0947|"
  }, "\u0915\u0932 RM \u091B\u0941\u091F\u094D\u091F\u0940 \u092A\u0930 \u0925\u0947|"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0906\u091C RM \u091B\u0941\u091F\u094D\u091F\u0940 \u092A\u0930 \u0939\u0948\u0902|"
  }, "\u0906\u091C RM \u091B\u0941\u091F\u094D\u091F\u0940 \u092A\u0930 \u0939\u0948\u0902|"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0906\u091C RM \u0915\u093E\u092E \u0915\u0930 \u0930\u0939\u0947 \u0939\u0948\u0902 \u092A\u0930 \u0915\u094B\u0908 \u092E\u0947\u0921\u093F\u0915\u0932 \u0907\u092E\u0930\u091C\u0947\u0902\u0938\u0940 \u0906 \u0917\u0908 \u0939\u0948|"
  }, "\u0906\u091C RM \u0915\u093E\u092E \u0915\u0930 \u0930\u0939\u0947 \u0939\u0948\u0902 \u092A\u0930 \u0915\u094B\u0908 \u092E\u0947\u0921\u093F\u0915\u0932 \u0907\u092E\u0930\u091C\u0947\u0902\u0938\u0940 \u0906 \u0917\u0908 \u0939\u0948|"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0907\u0928\u094D\u091F\u0930\u0928\u0947\u091F \u0915\u0940 \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0915\u0940 \u0935\u091C\u0939 \u0938\u0947 \u0938\u0947\u0902\u0921 \u0928\u0939\u0940\u0902 \u0915\u0930 \u092A\u093E \u0930\u0939\u0940|"
  }, "\u0907\u0928\u094D\u091F\u0930\u0928\u0947\u091F \u0915\u0940 \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0915\u0940 \u0935\u091C\u0939 \u0938\u0947 \u0938\u0947\u0902\u0921 \u0928\u0939\u0940\u0902 \u0915\u0930 \u092A\u093E \u0930\u0939\u0940|"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "RM \u0938\u0947 \u092C\u093E\u0924 \u0928\u0939\u0940\u0902 \u0939\u094B \u092A\u093E \u0930\u0939\u0940 \u0939\u0948|"
  }, "RM \u0938\u0947 \u092C\u093E\u0924 \u0928\u0939\u0940\u0902 \u0939\u094B \u092A\u093E \u0930\u0939\u0940 \u0939\u0948|"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u095E\u094B\u0928 \u0959\u0930\u093E\u092C \u0939\u0948 |"
  }, "\u095E\u094B\u0928 \u0959\u0930\u093E\u092C \u0939\u0948 |"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "New RM"
  }, "New RM"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0906\u091C \u0915\u093E \u0911\u0921\u093F\u091F \u0935\u093F\u091C\u093F\u091F \u0939\u0948 |"
  }, "\u0906\u091C \u0915\u093E \u0911\u0921\u093F\u091F \u0935\u093F\u091C\u093F\u091F \u0939\u0948 |"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
    value: "\u0911\u0921\u093F\u091F \u0911\u092B\u093F\u0938\u0930 \u0906 \u0930\u0939\u0947 \u0939\u0948\u0902 |"
  }, "\u0911\u0921\u093F\u091F \u0911\u092B\u093F\u0938\u0930 \u0906 \u0930\u0939\u0947 \u0939\u0948\u0902 |")))) : "", /*#__PURE__*/_react.default.createElement(_antd.Form.Item, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    htmlType: "submit"
  }, "Submit")));
};

var _default = AuditForm;
exports.default = _default;